package com.example.mystybag.common.views

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import com.example.mystybag.common.extensions.rippleClick
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.expected.LogHelper
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.ui.theme.LocalTheme.p0
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.views.AppTheme

/**
 * Общо заглавие за всички Action Sheet-и:
 * - Индикатор (дърпаща линия) отгоре, центриран
 * - 12dp отстояние под индикатора
 * - Заглавие центрирано (ако е подадено)
 * - 16dp отстояние под заглавието до първия елемент
 */
@Composable
fun ActionSheetHeader(
    title: String? = null,
    showDivider: Boolean = false,
    onCloseClick: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        if (!title.isNullOrBlank()) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = p16, bottom = p16)
            ) {
                Texts.TitleLarge(
                    text = title,
                    textAlign = androidx.compose.ui.text.style.TextAlign.Center,
                    color = AppTheme.current.colors.onSurface,
                    modifier = Modifier.align(Alignment.Center)
                )
                if (onCloseClick != null && PlatformHelper.isWeb) {
                    WebDialogCloseButton(
                        modifier = Modifier
                            .align(Alignment.CenterEnd)
                            .size(40.dp),
                        debugName = "ActionSheetHeader:${title}",
                        onClick = {
                            LogHelper.logEvent("[WebDialogCloseButton] ActionSheetHeader onCloseClick invoked title='${title}'")
                            onCloseClick()
                        }
                    )
                }
            }
        } else {
            Box(modifier = Modifier.padding(top = p16, bottom = p16))
        }

        if (showDivider) {
            HorizontalDivider(color = AppTheme.current.colors.outlineVariant)
        }
    }
}

@Composable
fun WebDialogCloseButton(
    modifier: Modifier = Modifier,
    debugName: String = "unknown",
    onClick: () -> Unit
) {
    Box(
        modifier = modifier
            .clip(CircleShape)
            .zIndex(10f)
            .rippleClick(padding = p0, roundPadding = 20.dp) {
                LogHelper.logEvent("[WebDialogCloseButton] hit captured debugName='$debugName'")
                onClick()
            },
        contentAlignment = Alignment.Center
    ) {
        Icon(
            imageVector = WebCloseIcon,
            contentDescription = null,
            tint = AppTheme.current.colors.onSurface,
            modifier = Modifier.size(22.dp)
        )
    }
}

private val WebCloseIcon: ImageVector = ImageVector.Builder(
    name = "WebClose",
    defaultWidth = 24.dp,
    defaultHeight = 24.dp,
    viewportWidth = 24f,
    viewportHeight = 24f
).apply {
    path(fill = SolidColor(Color.Black)) {
        moveTo(18.3f, 5.71f)
        lineTo(12f, 12f)
        lineTo(18.3f, 18.29f)
        lineTo(16.89f, 19.7f)
        lineTo(10.59f, 13.41f)
        lineTo(4.29f, 19.7f)
        lineTo(2.88f, 18.29f)
        lineTo(9.17f, 12f)
        lineTo(2.88f, 5.71f)
        lineTo(4.29f, 4.3f)
        lineTo(10.59f, 10.59f)
        lineTo(16.89f, 4.3f)
        close()
    }
}.build()
